import { OrderDTO } from '../models/order';
import OrderItem from '../types/OrderItem';
import mapOrderToDisplayItems from './mapOrderToDisplayItems';

const parseOrderToOrderItem = (orders: OrderDTO[]): OrderItem[] => orders
  .filter((o) => o.items && o.items.length > 0)
  .flatMap((order) => order.items.map((item) => mapOrderToDisplayItems(order, item)));

export default parseOrderToOrderItem;
